import React from "react";
import ExploreOurServices from "../../assets/images/home/ExploreOurServicesImg.webp";
import "./index.css";
import { Link } from "react-router-dom";

export const ExploreSection = () => {
  return (
    <div className="exploreContainer">
      <div className="container">
        <div className="exploreTitle">Explore Our Services</div>
        <div className="exploreDesc">
          Empowering your journey—get the support you need, or make a real
          difference by listening.
        </div>
      </div>
      <div className="container-fulid exploreGridWorkingSection">
        <div className="exploreGrid">
          <div className="exploreCard">
            <div className="exploreCardHeadding">For Support Seekers</div>
            <ul className="exploreCard-list">
              <li>
                <span>Instant, Confidential Support:</span>
                <p>
                  Chat or voice online instantly, or schedule an in-person
                  session for a face-to-face experience.
                </p>
              </li>
              <li>
                <span>Anonymous or Verified:</span>
                <p>
                  You’re in control. Join with just a nickname or create a
                  profile when you’re ready.
                </p>
              </li>
              <li>
                <span>Smart Matching:</span>
                <p>
                  Get paired by language, specialty, or mood—so you always find
                  the right listener.
                </p>
              </li>
              <li>
                <span>In-Person Sessions:</span>
                <p>
                  Meet certified listeners in vetted public spaces for added
                  human connection.
                </p>
              </li>
            </ul>
            <a
              href={`${process.env.REACT_APP_LISTENAURA_APP_URL}`}
              target="_blank"
            >
              <button className="exploreSectionPrimaryBtn">
                Start Your Session
              </button>
            </a>
          </div>

          <div className="exploreCard exploreCardImgWrapper">
            <img src={ExploreOurServices} alt="Explore Services" />
          </div>

          <div className="exploreCard">
            <div className="exploreCardHeadding">For Potential Listeners</div>
            <ul className="exploreCard-list">
              <li>
                <span>Become a Certified Listener:</span>
                <p>
                  Offer both online and in-person sessions to match your
                  expertise and comfort.
                </p>
              </li>
              <li>
                <span>Flexible Hours & Remote Work:</span>
                <p>Support others on your own schedule—wherever you are.</p>
              </li>
              <li>
                <span>Earn, Grow, Make Impact:</span>
                <p>Get paid, earn badges, and see your real-world impact.</p>
              </li>
              <li>
                <span>Seamless Onboarding:</span>
                <p>
                  Join with a simple application, clear guidelines, and quick
                  certification.
                </p>
              </li>
            </ul>
            <Link to="/become-a-listener">
              <button className="exploreSectionOutLineBtn">
                Become a Listener
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
